import { render } from "./CategoriesView.vue?vue&type=template&id=7808379e"
import script from "./CategoriesView.vue?vue&type=script&lang=js"
export * from "./CategoriesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__